// Title || Status <=> Optional Right Element ==> Action buttons
import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from '@cko/primitives';
import StatusWithTooltip from './StatusWithTooltip';
const ActionButtonsFlex = styled(Flex) `
  & button {
    margin: var(--layout-sandgrain);
    white-space: nowrap;
  }
`;
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const NewPanelHeader = (props) => {
    const { title, actionButtons, status, tooltip, rightElement } = props;
    return (React.createElement(Box, { as: "header" },
        React.createElement(Flex, { justifyContent: "space-between", flexWrap: "wrap", gridGap: "var(--layout-spoon)" },
            React.createElement(Flex, { alignItems: "center" },
                React.createElement(Box, null, title),
                status && (React.createElement(Flex, { ml: "var(--layout-spoon)" },
                    React.createElement(StatusWithTooltip, { status: status, tooltip: tooltip }))),
                rightElement),
            React.createElement(ActionButtonsFlex, { justifyContent: "flex-end", flexWrap: "nowrap", gridGap: "var(--layout-soybean)" }, actionButtons))));
};
